import React from 'react';
import { Card, CardBody, CardSubtitle, CardText, CardTitle } from 'reactstrap';

import { BrandLinks } from '../../brands/Link';
import CurrencyFormat from '../../generic/CurrencyFormat';
import Details from '../../generic/Details';
import StatusStackedBar from '../../generic/StatusStackedBar/StatusStackedBar';
import OpportunityLink from '../../opportunities/OpportunityLink';
import { basicCampaignShape } from '../../prop-types';
import CampaignLink from '../CampaignLink';
import { getStatusBarItems } from '../utils/utils';

function CampaignCard({ campaign }) {
  const details = [
    { label: 'Start', value: campaign.startDatePlan },
    { label: 'End', value: campaign.endDatePlan },
  ];
  return (
    <Card className="c-compact-card mb-3">
      <StatusStackedBar items={getStatusBarItems(campaign)} />
      <CardBody className="c-compact-card__body">
        <CardTitle className="c-compact-card__title">
          {campaign.nCode}{' '}
          <CampaignLink className="campaign-popover-in-card" model={campaign} />
        </CardTitle>
        <CardText>
          Spendable Budget:{' '}
          <CurrencyFormat
            name="spendableBudget"
            value={campaign.spendableBudget || 0}
            decimalScale={0}
            text
          />
        </CardText>
        <CardText className="mb-0">
          <span className="text-muted">Co Invest:</span>{' '}
          <CurrencyFormat
            name="coInvest"
            className="text-muted"
            value={campaign.coInvest || 0}
            decimalScale={0}
            text
          />
        </CardText>
        <CardText className="mb-0">
          <span className="text-muted">Free Service:</span>{' '}
          <CurrencyFormat
            name="freeService"
            className="text-muted"
            value={campaign.freeService || 0}
            decimalScale={0}
            text
          />
        </CardText>
        <CardText className="mb-0">
          <span className="text-muted">Net Client Budget External:</span>{' '}
          <CurrencyFormat
            name="netClientBudgetExternal"
            className="text-muted"
            value={campaign.netClientBudgetExternal || 0}
            decimalScale={0}
            text
          />
        </CardText>
        <CardText>
          <span className="text-muted">WKZ Budget:</span>{' '}
          <CurrencyFormat
            name="wkzBudget"
            className="text-muted"
            value={campaign.wkzBudget || 0}
            decimalScale={0}
            text
          />
        </CardText>
        <CardSubtitle className="mb-3">
          <ul className="list-unstyled">
            <li>
              <BrandLinks
                className="popover-in-card"
                separator=", "
                models={campaign.brands}
              />
            </li>
            <li>
              <OpportunityLink
                className="popover-in-card"
                model={campaign.opportunity}
                title="Open opportunity page"
              >
                Open opportunity
              </OpportunityLink>
            </li>
          </ul>
        </CardSubtitle>

        <Details
          className="c-compact-card__details mb-0"
          labelClassName="c-compact-card__detail-label"
          valueClassName="mb-0"
          data={details}
        />
      </CardBody>
    </Card>
  );
}

CampaignCard.propTypes = {
  campaign: basicCampaignShape.isRequired,
};

export default CampaignCard;
